import React, { forwardRef } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import NexposeMappingForm from './NexposeMappingForm';

function NexposeCredentialsForm(props, ref){
    const fields = [{
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules:[urlRegexValidator],
    }, {
        name: "username",
        label: "Username",
        required: true,
    }, {
        name: "password",
        label: "Password",
        type: FieldTypes.PASSWORD,
        required: true
    }]
    
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={NexposeMappingForm}
        />
    )
}

export default forwardRef(NexposeCredentialsForm);